import React from "react";

// Default components
import {defaultComponents} from "./../components/_default/interfaces/DefaultComponents"
import ContentRenderer from "./../components/_default/ContentRenderer"
import MetadataComponent from "./../components/_default/MetadataComponent";
import CheckNotFoundPage from "./../components/_default/CheckNotFoundPage";
import { useAppSelector, useAppDispatch } from "./../store/hooks"

window.defaultComponents = defaultComponents;

export default function Webpage453notfound() {
        const page_seo = {
                    seo_title: 'notfound - test-react3.itpr.eu',
                    canonical: 'https:\/\/test-react3.itpr.eu\/et\/*',
            }
    
    const dispatch = useAppDispatch();
    
    React.useEffect(() => {
        dispatch({
            type: "SET_WEBPAGE_ACTIVE",
            payload: 453
        });
    }, [])
    
    React.useEffect(() => {
        dispatch({
            type: "UPDATE_STRUCTURE",
            payload: {"webpageComponents":[11417],"components":{"11417":{"id":11417,"uuid":"019cde64-82a2-72f9-831f-291a1ae7f683","language_id":null,"parent_id":null,"webpage_id":453,"type":"section","sort_order":0,"version":1,"attributes":{"classes":"row","content_width_unit":"%","content_width_size":100,"styles":{"paddingTop":"60px","paddingLeft":"60px","paddingRight":"60px","paddingBottom":"60px"}},"childWebpageComponentRelations":[]}}}        });
    }, [])
    
    
    
    return (
        <>
            <CheckNotFoundPage/>
            <MetadataComponent page_seo={page_seo} />
            <ContentRenderer />
        </>
    );
}